'use strict';

import BaseService from './base.service';

class VouchersService extends BaseService {
    /* @ngInject */
    constructor(
        Voucher,
        SegaUser
    ) {
        super(Voucher, SegaUser);
        this.defaultOrder = 'createdAt DESC';
    }

    void(opts = {id: 0, reason: ''}) {
        return this.Model.void({
            id: opts.id,
            reason: opts.reason
        }).$promise;
    }

    createNew(opts = {}) {
        return this.Model.createNew({
            opts: opts
        }).$promise;
    }

    addCashReturn(opts = { id: 0, amount: 0, comments: ''}) {
        return this.Model.addCashReturn(opts).$promise;
    }

    voidCashReturn(opts = { voucherId: 0, cashboxTxId: 0}) {
        return this.Model.voidCashReturn(opts).$promise;
    }

    findCashReturns(id) {
        return this.Model.findCashReturns({
            id: id
        }).$promise;
    }

    getModels(opts = {}) {
        return this.getQueryOpts(opts).then(queryOpts => {
            return this.Model.findVouchers({
                filter: queryOpts
            }).$promise;
        });
    }

}

export default VouchersService;
